export default __webpack_public_path__ + "static/media/inst.51549143.svg";